import { InvalidCredentialsError } from "../../../domain/errors/invalid-credentials-error";
import { UnexpectedError } from "../../../domain/errors/unexpected-error";
import {
  DeveloperPackage,
  DeveloperPackageProps,
  DeveloperPackageResponseModel,
} from "../../../domain/models/developer-package.model";
import { FilterModel } from "../../../domain/models/enum";
import { HttpClient, HttpStatusCode } from "../../protocols/http/http-client";

export class RemoteDeveloperPackage implements DeveloperPackage {
  constructor(
    private readonly url: string,
    private readonly httpPostClient: HttpClient,
    private readonly baseUrl: string | undefined
  ) {}

  async load(params: FilterModel): Promise<DeveloperPackageResponseModel> {
    const httpResponse = await this.httpPostClient.request({
      url: `${this.url}`,
      method: "get",
      params,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }

  async create(body: DeveloperPackageProps): Promise<DeveloperPackageProps> {
    const httpResponse = await this.httpPostClient.request({
      url: this.url,
      method: "post",
      body,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.created:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }

  async delete(id: number): Promise<DeveloperPackageProps> {
    const httpResponse = await this.httpPostClient.request({
      url: `${this.url}/${id}`,
      method: "delete",
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      case HttpStatusCode.conflict:
        throw httpResponse.body;
      default:
        throw new UnexpectedError();
    }
  }

  async loadById(id: number): Promise<DeveloperPackageProps> {
    const httpResponse = await this.httpPostClient.request({
      url: `${this.url}/${id}`,
      method: "get",
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }

  async update(
    id: number | undefined,
    body: DeveloperPackageProps
  ): Promise<DeveloperPackageProps> {
    const httpResponse = await this.httpPostClient.request({
      url: `${this.url}/${id}`,
      method: "put",
      body,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
